import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// This is the Angular service that calls the C# REST service
import { DistributorsCountService } from 'src/app/services/distributorsCount/distributorsCount.service';

// These are the supporting files for the component
@Component({
    selector: 'app-distributorsCount-card',
    templateUrl: './distributorsCount-card.component.html',
    styleUrls: ['./distributorsCount-card.component.scss'],
})
export class DistributorsCountCardComponent implements OnInit {

    // This is the Behavior you will reference in the HTML
    distributorsCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _distributorsCountService: DistributorsCountService
    ) {

    }

    ngOnInit() {
        this._distributorsCountService.getDistributorsCount$().subscribe(result => {
            this.distributorsCount$.next(result.scalar);
        });
    }
}
